/**
 * API Configuration
 * Spoonacular API proxy settings
 */
export const PROXY_URL = import.meta.env.VITE_API_URL;
export const PROXY_KEY = import.meta.env.VITE_API_KEY;


